// Configurations for different paths
const baseUrl = 'https://predyxiq.com'; 
const apiBaseUrl = 'https://api.predyxiq.com/api/admin'; // Replace with your API base URL
const apiUrl = 'https://predyxiq.com'; 
export { baseUrl,apiBaseUrl,apiUrl };
